import axios from "axios"


const request = axios.create({
})

export const PostCollect = async (body) => {
    if (window.env && window.env.__IS_CUSTOUCH_ENV) {
        return request.post(`${window.env.__IS_LOCAL ? "https://alibabaceshi.beta.pageseagle.com" : ""}/collect/event`, body)
    }
    return
}
